import React from 'react';
import IconDelete from 'images/trash3.png'

// タッチ位置から対象行indexを求める
const rowIndexFromPoint = (clientX, clientY) => {
  const el = document.elementFromPoint(clientX, clientY);
  if (!el) return null;
  const tr = el.closest('tr[data-url-row]');
  if (!tr) return null;
  const idx = tr.getAttribute('data-url-row');
  return idx === null ? null : parseInt(idx, 10);
};

const DragHandle = ({ no, onMouseDown, onTouchStart, onTouchMove, onTouchEnd }) => (
  <span
    className='url-drag-handle'
    title='ドラッグして並べ替え'
    onTouchStart={onTouchStart}
    onTouchMove={onTouchMove}
    onTouchEnd={onTouchEnd}
    style={{ display:'inline-flex', alignItems:'center', gap:'10px', cursor:'grab', userSelect:'none', color:'#9aa0a6', padding:'2px 4px', touchAction:'none' }}
  >
    <span style={{ fontWeight:700, fontSize:'14px', color:'#5f6368', minWidth:'14px', textAlign:'center' }}>{no}</span>
    <svg width="12" height="18" viewBox="0 0 12 18" fill="none" xmlns="http://www.w3.org/2000/svg" aria-hidden="true">
      <path d="M6 1.5 L2.5 5 M6 1.5 L9.5 5 M6 1.5 V8" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
      <path d="M6 16.5 L2.5 13 M6 16.5 L9.5 13 M6 16.5 V10" stroke="currentColor" strokeWidth="1.4" strokeLinecap="round" strokeLinejoin="round"/>
    </svg>
  </span>
);

const TableUrlToCapture = ({ urls, handleDeleteUrl, changeUrl, getAccountByDomain, addUrl, handleCaptureUrls, isDisableCapture, isProcessing, onCancel, dragIndex, setDragIndex, handleReorderUrl, handlePasteUrls, handleDropUrl }) => {
  const onTouchStart = (index) => () => { setDragIndex && setDragIndex(index); };
  const onTouchMove = (e) => {
    if (dragIndex === null) return;
    const t = e.touches[0];
    if (t) e.preventDefault();
  };
  const onTouchEnd = (e) => {
    if (dragIndex === null) return;
    const t = (e.changedTouches && e.changedTouches[0]);
    if (t) {
      const to = rowIndexFromPoint(t.clientX, t.clientY);
      if (to !== null && handleReorderUrl) handleReorderUrl(to);
      else setDragIndex && setDragIndex(null);
    } else {
      setDragIndex && setDragIndex(null);
    }
  };

  return (
  <div className=''>
    <div className='d-flex text-center justify-content-center align-items-center mt-2 mx-3 border-1px-black'>
      <div className='w-80'>
        <div className='text-left mb-1 d-flex align-item-center'>
          <button className='btn btn-mint plus plus-icon p-0 text-center add-url-file' type='button' onClick={addUrl}>
            +
          </button>
          <span className='text-black fs-14 ml-1 text-underline cursor-pointer' onClick={addUrl}>URLを追加する</span>
        </div>
        <div className='show-table-files' style={{borderRadius:'8px',boxShadow:'0 2px 8px rgba(0,0,0,0.2)',overflow:'visible',maxHeight:'none'}}
             onDragOver={(e) => { e.preventDefault(); }}
             onDrop={(e) => { handleDropUrl && handleDropUrl(e); }}>
          <div>
          <table className='w-100 table mb-1' style={{border:'none'}}>
            <thead className='bg-black w-100 text-white'>
              <tr>
                <th width="22%" style={{whiteSpace:'nowrap', padding:'4px'}}>並び替え</th>
                <th width="14%" style={{whiteSpace:'nowrap', padding:'4px'}}>削除</th>
                <th className='text-center'>URL</th>
              </tr>
            </thead>
            <tbody className=''>
              {urls.map((item, index) => (
                <tr key={index} data-url-row={index}
                    onDragOver={(e) => e.preventDefault()}
                    onDrop={(e) => { e.preventDefault(); handleReorderUrl && handleReorderUrl(index); }}
                    style={{ borderBottom: '1px solid #dee2e6', ...(dragIndex === index ? { opacity: 0.4 } : {}) }}>
                  <td
                    draggable={true}
                    onDragStart={() => setDragIndex && setDragIndex(index)}
                    onDragEnd={() => setDragIndex && setDragIndex(null)}
                    style={{padding:'4px', border:'none', borderRight:'1px solid #dee2e6', textAlign:'center', verticalAlign:'middle'}}>
                    <DragHandle
                      no={urls.length - index}
                      onTouchStart={onTouchStart(index)}
                      onTouchMove={onTouchMove}
                      onTouchEnd={onTouchEnd}
                    />
                  </td>
                  <td style={{padding: '4px', border:'none', borderRight:'1px solid #dee2e6', textAlign:'center', verticalAlign:'middle'}}>
                    <img className='filter-black-icon cursor-pointer' width={15} src={IconDelete}
                         onClick={() => handleDeleteUrl(item, index)} />
                  </td>
                  <td className='text-left' style={{padding: '0px 0px 0px 0px', border:'none', verticalAlign:'middle'}}>
                    <input className='input-url-multiple' style={{paddingLeft:'5px'}} type='text'
                      value={item} onChange={(event) => changeUrl(event, index)}
                      onPaste={(event) => handlePasteUrls && handlePasteUrls(event)}
                      onDrop={(event) => handleDropUrl && handleDropUrl(event)}
                      onDragOver={(event) => event.preventDefault()}
                      onBlur={(event) => getAccountByDomain(event, item)} placeholder='URLを入力してください。'/>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
          </div>
        </div>
        <div className='text-left mt-1' style={{fontSize:'12px', color:'#666'}}>※番号の小さい順にキャプチャされます。</div>
      </div>
    </div>
    <div className='text-center create-akaire-box-content my-3'>
      <button type='button' className='btn' style={{backgroundColor:'#595959',color:'#fff',borderRadius:'8px',boxShadow:'0 2px 6px rgba(0,0,0,0.35)'}} disabled={isDisableCapture && !isProcessing} onClick={(event) => handleCaptureUrls(event)}>キャプチャする</button>
      <button type='button' className='btn btn-secondary ml-2' onClick={() => onCancel && onCancel()}>キャンセル</button>
    </div>
  </div>
  );
};
export default TableUrlToCapture;
